"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceUtils = exports.PriceDtoFactory = void 0;
var bookings_uou_mappers_1 = require("@wix/bookings-uou-mappers");
var PriceDtoFactory = /** @class */ (function () {
    function PriceDtoFactory() {
    }
    PriceDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            currency: offeringDto.payment.currency,
            price: offeringDto.payment.price,
            isFree: offeringDto.payment.isFree,
            isVariedPricing: offeringDto.payment.isVariedPricing,
            priceText: offeringDto.payment.priceText,
            minCharge: offeringDto.payment.minCharge,
            paymentType: offeringDto.payment.paymentType,
            displayTextForPlan: offeringDto.pricingPlanInfo
                ? offeringDto.pricingPlanInfo.displayText
                : '',
        };
    };
    return PriceDtoFactory;
}());
exports.PriceDtoFactory = PriceDtoFactory;
var PriceUtils = /** @class */ (function () {
    function PriceUtils() {
    }
    PriceUtils.getFormattedCurrency = function (input) {
        return bookings_uou_mappers_1.PriceUtils.getFormattedCurrency(input);
    };
    return PriceUtils;
}());
exports.PriceUtils = PriceUtils;
//# sourceMappingURL=price-dto-factory.js.map